module.exports = __webpack_public_path__ + "static/media/button-edit-upload-active.9eeeacde.svg";